export function ScoreRow({ players, index, item }) {
	return (
		<td className="stats__row__data">
			{players[index][item]}
			{players[index][item] > players[(index + 1) % 2][item] && (
				<span className="text-yellow-400">⭐</span>
			)}
		</td>
	)
}
